<template>
  <div class="card-panel">
    <h1 class="large-text">Has terminado</h1>
    <form @submit.prevent="send">
      <div class="input-field">
        <textarea id="textarea1" v-model="suggestion" class="materialize-textarea"></textarea>
        <label class="size" for="textarea1">Recomendaciones y comentarios para el evaluado</label>
      </div>

      <p>{{response}}</p>

      <button class="btn waves-effect indigo">
        <i class="material-icons left">send</i>
        Enviar
      </button>
    </form>
  </div>
</template>
<script>
import axios from "axios";
import { mapState } from "vuex";

export default {
  data() {
    return {
      user: this.$route.params.user,
      title: this.$route.params.campainName,
      displayTitle: this.urlToString(this.$route.params.campain).toUpperCase(),

      suggestion: "",
      response: ""
    };
  },
  computed: {
    ...mapState([
      "evaluator",
      "calculatedAspects",
      "reactivesAnswers",
      "frequency",
	  "qualification",
	  "evaluators",
	  "thisCampain"
    ])
  },
  methods: {
    send() {
      this.response = "";
      this.buttonDisabled = true;
      let data = {
        frequency: this.frequency,
        qualification: this.qualification,

        name: this.evaluator.name,
        stall: this.evaluator.stall,
        area: this.evaluator.area,
        relation: this.evaluator.relation,
        email: this.evaluator.email,

        suggestion: this.suggestion.replace(/(\r\n\t|\n|\r\t)/g, ""),
        aspects: JSON.stringify(this.calculatedAspects),
        user: this.user,
        title: this.displayTitle.toLowerCase(),
        reactivesAnswers: JSON.stringify(this.reactivesAnswers),

	  };
	  //console.log(data)

	  this.updateActive();

      axios
        .post(
          "https://evaluacion-360.human-express.com/php/questionnaire/create.php",
          this.createFormData(data)
        )
        .then(response => {
          console.log(response.data);
          if (response.data.status) {
            M.toast({
              html: response.data.message
            });
            setTimeout(() => {
              location.href = "https://google.com";
            }, 1000);
          } else {
            this.response = response.data.message;
          }
        })
        .catch(error => {
          this.response =
            "No se pudo procesar la información, intentalo de nuevo más tarde";
          M.toast({
            html:
              "No se pudo procesar la información, intentalo de nuevo más tarde"
          });
        });
	},
	updateActive(){

		this.evaluators.forEach(evaluator => {
				if (evaluator.email == this.evaluator.email) {

					if (evaluator.userCode == this.evaluator.userCode) {
						evaluator.active = false;
						evaluator.finished = true;
					} else {
						M.toast({
						html: "No puedes acceder a la evaluación en este momento"
						});
					}
				}
			});

		//console.log(this.evaluators)
		//console.log(this.thisCampain)

		var data = {
			evaluators: JSON.stringify(this.evaluators),
			uid: this.thisCampain.id
		};

		axios
        .post(
          "https://evaluacion-360.human-express.com/php/evaluations/evaluators/update.php",
          this.createFormData(data)
        )
        .then(response => {
          //M.toast({ html: response.data.message });
        })
        .catch(error => {
          this.status = false;
          M.toast({ html: "Ha ocurrido un error: " + error });
        });
	},
    urlToString(string) {
      return string.replace(/-/g, " ");
    },
    createFormData(postData) {
      var formDa = new FormData();
      for (var key in postData) {
        formDa.append(key, postData[key]);
      }
      return formDa;
    }
  }
};
</script>

<style scoped>
	.size{
		font-size: 1.2rem;
	}
</style>



// WEBPACK FOOTER //
// src/components/questionnaire/questionnaireSteps/finish.vue